import React, { useEffect, useState } from "react"
import { SAFELITE_LOGO } from "../constants/offers"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { Redirect } from "react-router-dom"
import { getPartnerFeatureFlag } from "../../shared_component/utils/partnerFeatureFlag"

function AutoGlass({ t, user }) {
  const [partnerFlag, setPartnerFlag] = useState()

  useEffect(() => {
    getFeatureFlagResult()
  }, [])

  const getFeatureFlagResult = async () => {
    const result = await getPartnerFeatureFlag(user)
    setPartnerFlag(result)
  }
  return (
    <>
      {partnerFlag === false ? (
        <Redirect to="/dashboard" />
      ) : (
        <div className="deprecated-content">
          <div className="autoglass-header">
            <Link to="/offers">
              <FontAwesomeIcon icon={faArrowLeft} />
            </Link>
            <h2 class="primary-font confident-blue autoglass-heading">{t("header")}</h2>
          </div>
          <div className="offer">
            <img src={SAFELITE_LOGO} width="200" style={{ margin: "0 auto" }} />
            <p>
              {t("saveText")}
              <a
                className="secondary-font primary-color"
                href="https://ad.doubleclick.net/ddm/trackclk/N1068.2825COMMISSIONJUNCTION/B25410315.314730328;dc_trk_aid=506959616;dc_trk_cid=146182569;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd=?https://www.safelite.com/cjreplace-30?promo=CJ30RPLC&utm_source=cjunction&utm_medium=affiliate&utm_campaign=cjreplace"
                target="_blank"
              >
                <u>{t("safeLiteOfferDescriptionReplacement")}</u>
              </a>
              {t("andText")}
              <a
                className="secondary-font primary-color"
                href="https://ad.doubleclick.net/ddm/trackclk/N1068.2825COMMISSIONJUNCTION/B25410315.314976713;dc_trk_aid=507698287;dc_trk_cid=146182569;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd=?https://www.safelite.com/cjrepair-15?promo=15RPRCJ&utm_source=cjunction&utm_medium=affiliate&utm_campaign=15RPRCJ"
                target="_blank"
              >
                <u>{t("safeLiteOfferDescriptionRepair")}</u>
              </a>
              {t("withText")} Safelite.
            </p>
          </div>
        </div>
      )}
    </>
  )
}

function mapStateToProps(state) {
  let user = state.user
  return {
    user: user
  }
}

export default connect(mapStateToProps)(withTranslation("autoGlass")(AutoGlass))
